import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { VoiceITXRawReportSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportVoiceITXRawReport, sortVoiceITXRawReport } from '../../constants';
import {
  getRawInterconnectVoiceReportData,
  getListAllRawInterconnectVoiceReportData,
  onResetDefaultData,
} from '../../actions';
import { makeGetListRawInterconnectVoice, makeGetListAllRawInterconnectVoice } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import ModalOperatorMapListMultiSelect from '../../../../components/common/ModalOperatorMapListMultiSelect';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;
class VoiceITXRawReport extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listVoiceITXRawReport: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listVoiceITXRawReport: props.listVoiceITXRawReport,
      totalCount: getPageTotalCount({ ...state, items: props.listVoiceITXRawReport }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetDataServiceReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetDataServiceReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listRawInterconnectVoice');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListVoiceITXRawReport();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListVoiceITXRawReport());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListVoiceITXRawReport());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListVoiceITXRawReport();
    });
  };

  doGetListVoiceITXRawReport = () => {
    const { filter, page, size, sorted } = this.state;
    const { getRawInterconnectVoiceReportData } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortVoiceITXRawReport[sorted.sortCol]
          ? sortVoiceITXRawReport[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getRawInterconnectVoiceReportData(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistVoiceITXRawReport = cb => {
    const { filter, sorted } = this.state;
    const { getListAllRawInterconnectVoiceReportData } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortVoiceITXRawReport[sorted.sortCol][sorted.sortDir] : null,
    };
    getListAllRawInterconnectVoiceReportData(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistVoiceITXRawReport(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllVoiceITXRawReport, t } = this.props;
        convertJson2Pdf({
          data: listAllVoiceITXRawReport,
          t,
          title: t('reportPage:sidebar.interconnectVoiceReport').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.interconnectVoiceReport')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistVoiceITXRawReport(() => {
      const { listAllVoiceITXRawReport, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'EXCESS_VOICE_TRAFFIC_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.interconnectVoiceReport')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.interconnectVoiceReport')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllVoiceITXRawReport,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllVoiceITXRawReport,
          t,
          title: t('reportPage:sidebar.interconnectVoiceReport').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.interconnectVoiceReport')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.interconnectVoiceReport')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('RAW_ITX_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportVoiceITXRawReport,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listVoiceITXRawReport,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllVoiceITXRawReport,
      t,
      permissions: { modeGetDataServiceReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetDataServiceReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.interconnectVoiceReport') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.interconnectVoiceReport')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <VoiceITXRawReportSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  ModalSearch={props => {
                    return (
                      <div>
                        <ModalOperatorMapListMultiSelect
                          isOpen={props.isOpen === 'operatorId'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                          // accountId={id}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.interconnectVoiceReport').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllVoiceITXRawReport,
                          t,
                          title: t('reportPage:sidebar.interconnectVoiceReport').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.interconnectVoiceReport')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listVoiceITXRawReport}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listVoiceITXRawReport && listVoiceITXRawReport.length ? listVoiceITXRawReport : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

VoiceITXRawReport.propTypes = {
  getRawInterconnectVoiceReportData: PropTypes.func,
  getListAllRawInterconnectVoiceReportData: PropTypes.func,
  listAllVoiceITXRawReport: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

VoiceITXRawReport.defaultProps = {
  getRawInterconnectVoiceReportData: () => {},
  getListAllRawInterconnectVoiceReportData: () => {},
  listAllVoiceITXRawReport: [],
};

const mapStateToProps = createStructuredSelector({
  listVoiceITXRawReport: makeGetListRawInterconnectVoice() || [],
  listAllVoiceITXRawReport: makeGetListAllRawInterconnectVoice() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getRawInterconnectVoiceReportData,
    getListAllRawInterconnectVoiceReportData,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(VoiceITXRawReport)
);
